module.exports = __webpack_public_path__ + "img/signal-bars-good.5b47210b.svg";